wbApp.controller('HtmlContentCtrl', ['$scope', '$q', '$translate', '$timeout', 'contentSvc', 'notificationSvc', 'tenantSettingSvc',
function ($scope, $q, $translate, $timeout, contentSvc, notificationSvc, tenantSettingSvc) {

    $scope.enableNewClientDesign = tenantSettingSvc.settings.enableNewClientDesign;
    
    $scope.htmlContentType = 0;
    $scope.tabIndex = 4;

    $scope.init = function(htmlContentType, tabIndex)
    {
        $scope.htmlContentType = htmlContentType;
        $scope.tabIndex = tabIndex;
    }

    var isActive = false;
    var loaded = false;

    function loadData() {
        $scope.isBusy = true;
        $scope.model = contentSvc.getById($scope.htmlContentType);
        $scope.model.$promise.then(function () {
            $scope.modelOrig = angular.copy($scope.model);

            $scope.isBusy = false;
        }, function (error) {
            if (!!error && error.status == 404) {
                $scope.model = {
                    id: $scope.htmlContentType + '',
                    isNew: true,
                    htmlData: null,
                };
                $scope.modelOrig = angular.copy($scope.model);
            }
        });
    }

    $scope.$on('refreshData', function (e, data) {
        if (isActive) {
            loadData();
        }
    });

    $scope.$on('activeTabChanged', function (e, data) {
        if (data.activeTab === $scope.tabIndex) {
            if (!isActive) {
                isActive = true;

                if (!loaded) {
                    loadData();
                    loaded = true;
                }

                $timeout(function () {
                    angular.element('#terms-and-conditions-editor').trigger("resize");
                }, 100);
            }
        } else {
            isActive = false;
        }
    });

    $scope.onCancel = function () {
        loadData();
    }

    $scope.onModelSave = function (data) {

        if ($scope.isSaving) {
            return;
        }

        $scope.isSaving = true;

        if (!data.htmlData) {
            if (!data.isNew) {
                contentSvc.remove(data.id).$promise.then(function () {
                    data.id = $scope.htmlContentType + '';
                    data.isNew = true;
                    $scope.model = data;
                    $scope.modelOrig = angular.copy($scope.model);
                    $scope.isSaving = false;
                }, function (errorResult) {
                    $scope.isSaving = false;

                    notificationSvc.notifyError(
                        $translate.instant('TXT_ALERT_TITLE_ENTITY_SAVE_ERROR'),
                        notificationSvc.translateError(errorResult));
                });
            } else {
                $scope.isSaving = false;
            }
        }
        else {

            contentSvc.update(data).$promise.then(function () {
                $scope.model = data;
                $scope.model.isNew = false;
                $scope.modelOrig = angular.copy(data);

                $scope.isSaving = false;
            }, function (errorResult) {
                $scope.isSaving = false;

                notificationSvc.notifyError(
                    $translate.instant('TXT_ALERT_TITLE_ENTITY_SAVE_ERROR'),
                    notificationSvc.translateError(errorResult));
            });
        }
    }

    $scope.detailIsUnchanged = function (data) {
        return angular.equals(data, $scope.modelOrig);
    }
}]);
